import React from 'react'
import './App.css'
import './theme.css'
import { BrowserRouter } from 'react-router-dom'
import Main from './components/MainComponent'
import { useMsal, useIsAuthenticated } from '@azure/msal-react'
import { ThemeProvider } from './contexts/ThemeContext'

function AppContent() {
  const { instance } = useMsal()
  const isAuthenticated = useIsAuthenticated()

  React.useEffect(() => {
    if (!isAuthenticated) {
      // If not authenticated, redirect to login
      instance.loginRedirect({
        scopes: ['openid', 'profile', 'email'],
      })
    }
  }, [isAuthenticated, instance])

  if (!isAuthenticated) {
    return <div>Loading...</div>
  }

  return (
    <BrowserRouter>
      <Main />
    </BrowserRouter>
  )
}

function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  )
}

export default App
